import "./common/assets/index.scss";
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/app/App.js";
import { DefaultLoadingIndicator } from "./components/app/LoadingIndicator";

ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback={<DefaultLoadingIndicator/>}>
      <App />
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);
